import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { AddCourseDTO } from "./AddCourse";


type CourseResponse  = AddCourseDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const EditCourse = (data: Partial<AddCourseDTO> , id:string): Promise<CourseResponse> => {
    return axios.patch(`/course/${id}`, data)
        .then(response => response.data as CourseResponse);
};